module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    attrs: {
      "id": "clock"
    }
  }, [_c('circle', {
    staticClass: "cls-57",
    attrs: {
      "cx": "1010.5",
      "cy": "144.3",
      "r": "44"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-52",
    attrs: {
      "cx": "1010.5",
      "cy": "144.3",
      "r": "38.7"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-58"
  }, [_c('g', {
    staticClass: "cls-38"
  }, [_c('g', {
    staticClass: "cls-59"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, -0.07, 0.1, 0.06, 929.09, 162.39)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('line', {
    staticClass: "cls-60",
    style: ({
      transform: 'rotate(' + _vm.seconds + 'deg)'
    }),
    attrs: {
      "id": "seconds",
      "x1": "1010.5",
      "y1": "146.3",
      "x2": "1010.5",
      "y2": "111.1"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "cls-61",
    style: ({
      transform: 'rotate(' + _vm.minutes + 'deg)'
    }),
    attrs: {
      "id": "minutes",
      "x1": "1010.5",
      "y1": "146.3",
      "x2": "1010.5",
      "y2": "114.5"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "cls-62",
    style: ({
      transform: 'rotate(' + _vm.hours + 'deg)'
    }),
    attrs: {
      "id": "hours",
      "x1": "1010.5",
      "y1": "146.3",
      "x2": "1010.5",
      "y2": "118.3"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39cf5c04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_elements/Clock.vue
// module id = 565
// module chunks = 1